import TimesheetList from '@/pages/TimesheetList';
import TimesheetView from '@/pages/TimesheetView';

export default [
  {
    path: '/timesheet/approved',
    name: 'timesheet.approved',
    component: TimesheetList,
    meta: {
      title: '',
      requiresAuth: true,
      permissions: ['perm_view_all_timesheet'],
    },
  },
  {
    path: '/timesheet/:code',
    name: 'timesheet.view',
    component: TimesheetView,
    meta: {
      title: '',
      requiresAuth: true,
      permissions: ['perm_view_all_timesheet', 'perm_view_own_timesheet'],
    },
  },
];
